import { AuditLogsListingTemplate } from "../templates/AuditLogsListingTemplate";

export default function AuditLogsScreen() {
  return <AuditLogsListingTemplate />;
}
